import { FC, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { Dispatch } from 'redux';
import { useMeQuery, usePermissionsQuery } from './generated/graphql';
import { Home } from './pages/Home';
import { Login } from './pages/auth/Login';
import { AuthAction, AuthTypes } from './redux/auth/types';
import { Spinner } from './components/Spinner';

const Routes: FC = () => {
  const { data: user, loading: userLoading } = useMeQuery();
  const { data: permissions, loading: permissionsLoading } = usePermissionsQuery();
  const dispatch = useDispatch<Dispatch<AuthAction>>();
  
  useEffect(() => {
    if (user?.me.user) {
      dispatch({ type: AuthTypes.FETCH_AUTH_USER, payload: user.me.user });
    }
  }, [user?.me.user, dispatch]);

  useEffect(() => {
    if (permissions?.permissions) {
      dispatch({
        type: AuthTypes.FETCH_PERMISSIONS,
        payload: permissions.permissions,
      });
    }
  }, [permissions?.permissions, dispatch]);

  // Show spinner while loading user or permissions
  if (userLoading || permissionsLoading) {
    return <Spinner />;
  }
  
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/login" component={Login} />
        <Home />
      </Switch>
    </BrowserRouter>
  )
}

export default Routes;